<div class="my-6 flex flex-wrap w-full">
    <div class="w-full">
        <ngx-file-drop dropZoneLabel="Drop files here"
            (onFileDrop)="dropped($event)"
            [accept]="accept" [multiple]="multiple">
            <ng-template
                ngx-file-drop-content-tmp
                let-openFileSelector="openFileSelector"
                class="text-center">
                <span *ngIf="(multiple === false && uploadedFiles.length === 1)">
                    <span class="p-2">{{uploadedFiles[0].name || 'invalid file'}}</span> <button mat-stroked-button (click)="removeFile(uploadedFiles[0])">x</button>
                </span>
               
                <button *ngIf="multiple === true || (multiple === false && uploadedFiles.length === 0)" mat-stroked-button (click)="openFileSelector()"
                    [disabled]="uploading">Browse Files</button>
            </ng-template>
        </ngx-file-drop>
    </div>
     <div class="my-6 flex flex-wrap overflow-y-auto" style="max-height: 200px;">
        <mat-error *ngIf="invalidFiles.length">
            Not adding these files:
            <ul class="ml-8 list-inside list-disc">
                <li *ngFor="let file of invalidFiles">{{file}}</li>
            </ul>
        </mat-error>
    </div>
</div>
